/**
 * @param {File} image - Image File Object
 * @param {Object} pixelCrop - pixelCrop Object provided by react-image-crop
 * @param {String} fileName - Name of the returned file in Promise
 */
export async function cropImg(imageData, pixelCrop) {
  if (!imageData) {
    throw new Error("Unable to cropImg, imageData is undefined");
  }
  var img = await initImage(imageData);

  const canvas = document.createElement('canvas');
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(
    img,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  // As Base64 string
  const base64Image = canvas.toDataURL('image/jpeg');
  return base64Image;
}

/*Return the width and height of an img*/
export async function getImageInfo(img) {
  return {
    width: img.width,
    height: img.height
  };
}

/*Convert a base64 image to a blob (jpeg)*/
export function base64ImageToBlob(imageData) {
  const base64Data = imageData.replace(/^data:([A-Za-z-+/]+);base64,/, '');
  var buffer = new Buffer(base64Data, 'base64');
  return new Blob([buffer], { type: "image/jpeg" });
}

/* Initialises a non visible img */
export function initImage(imageData) {
  if (!imageData) {
    throw new Error("Unable to initImage, imageData is undefined");
  }
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.originClean = false;
  img.src = imageData;

  return new Promise((resolve, reject) => {
    img.onload = function() {
      try
      {
        resolve(img);
        return;
      } catch (err) {
        console.log(err);
        reject(err)
      }
    }
  })
}

export async function resizeImage(imageData, width, height) {
  var img = await initImage(imageData);

  const imgInfo = await getImageInfo(img);

  const scaleX = width/imgInfo.width;
  //const scaleY = height/imgInfo.height;

  var newWidth = imgInfo.width*scaleX;
  var newHeight = imgInfo.height*scaleX;

  const canvas = document.createElement('canvas');
  canvas.width = newWidth;
  canvas.height = newHeight;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(
      img,
      0,
      0,
      newWidth,
      newHeight);

  return canvas.toDataURL('image/jpeg');
}

export async function loadImgFromLocalFile(fileName) {
  let reader = new FileReader();
  reader.readAsDataURL(fileName);
  return new Promise((resolve, reject) => {
    reader.onloadend = () => {
      resolve(reader.result);
    }
  });
}



// WEBPACK FOOTER //
// ./src/lib/imageFunctions.js